var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FinalContainer", {
    attrs: {
      title: "The perfect outfit awaits",
      subtext:
        "You're all set! You can always use the filters to show outfits for specific seasons or price."
    }
  })
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08525c98", { render: render, staticRenderFns: staticRenderFns })
  }
}